import type { DeleteWelloCommentUsingPutData } from '__generated__/api/auth';
import { useToast } from '@common/hooks';
import { useMutation } from '@tanstack/react-query';

import { AuthApi, AuthQueryKey, UnauthQueryKey } from '@/api/v2';

export const useDeleteCommentMutation = () => {
  const { toastError } = useToast();

  return useMutation({
    mutationFn: (params: Pick<DeleteWelloCommentUsingPutData, 'path'>) =>
      AuthApi['put:/wello/v2/auth/wello-comment/{wello_comment_id}/delete'](
        params,
      ),
    meta: {
      reset: [
        AuthQueryKey['get:/wello/v2/auth/wello-comment'](),
        UnauthQueryKey['get:/wello/v2/allows/wello-comment'](),
        AuthQueryKey['get:/wello/v2/auth/wello-comment/my'](),
        AuthQueryKey['get:/wello/v2/auth/community/my'](),
      ],
    },
    onError: (error) => {
      toastError({ error });
    },
  });
};
